module.exports = __webpack_public_path__ + "img/contact-active.c1823403.png";